import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import AuthPage, { primaryBtn } from "@/components/account/AuthPage";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";

export default function Verify() {
  const { t } = useLang();
  useSeo({ title: `${t("auth.verifyTitle")} – Nivå Digital`, description: t("auth.verifying"), noindex: true });
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = params.get("token");
    if (!token) return setState("error");
    api.get("/auth/verify", { params: { token } }).then(() => setState("ok")).catch(() => setState("error"));
  }, [params]);

  return (
    <AuthPage tag={t("nav.account")} title={t("auth.verifyTitle")} testid="verify-page">
      <div className="flex flex-col items-center py-6 text-center">
        {state === "loading" && (
          <>
            <Loader2 data-testid="verify-loading" className="h-10 w-10 animate-spin text-mint" />
            <p className="mt-5 text-sm text-fog">{t("auth.verifying")}</p>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-mint" />
            <h2 data-testid="verify-success" className="mt-5 font-display text-xl font-bold text-bone">{t("auth.verified")}</h2>
            <p className="mt-3 text-sm leading-relaxed text-fog">{t("auth.verifiedText")}</p>
            <Link data-testid="verify-login-link" to="/logga-in" className={`${primaryBtn} mt-8`}>{t("auth.loginBtn")}</Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="h-12 w-12 text-red-400" />
            <h2 data-testid="verify-error" className="mt-5 font-display text-xl font-bold text-bone">{t("auth.verifyFailed")}</h2>
            <p className="mt-3 text-sm leading-relaxed text-fog">{t("auth.verifyFailedText")}</p>
            <Link data-testid="verify-error-login-link" to="/logga-in" className="mt-6 text-sm font-semibold text-mint hover:underline">{t("auth.loginLink")}</Link>
          </>
        )}
      </div>
    </AuthPage>
  );
}
